export class KDSUserTypePermission {
    id: number;    
    user_type_id: number;   
    permission_id: number; 
    created_at?: string;    
}